import './style.scss';

export function branches_block() {
    const block = document.querySelector('.branches_block');
    if (!block) return;

}
